import React from "react";

import {
  Document,
  Page,
  View,
  Text,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { Row, Col } from "antd";

import Logo from "../../../../../assets/Logo.png";
import moment from "moment";
const { ToWords } = require("to-words");
const toWords = new ToWords({
  localeCode: "en-IN",
  converterOptions: {
    currency: true,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
    doNotAddOnly: false,
  },
});
const styles = StyleSheet.create({
  page: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: 30,
  },
  mainHeader: {
    display: "flex",
    padding: "0px 20px",
    paddingTop: "10px",
    // justifyContent: "space-between",
    flexDirection: "column",
    alignItems: "center",
    color: "black",
    // backgroundColor: "#284F68",
  },
  headerLogo: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    padding: "10px",
  },
  headerTextSection: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    color: "black",
    fontSize: 12,
    textAlign: "center",
  },
  taxPersonsSection: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    color: "black",
    textAlign: "left",
  },
  headingText: {
    fontSize: "23px",
    marginBottom: "5px",
    // color: "#fff",
    display: "block",
  },
  propertyDetailsContainer: {
    display: "block",
    width: "100%",
    border: "black 1px solid",
    marginTop: 40,
  },
  footer: {
    display: "block",
    width: "100%",
    marginTop: 40,
  },
  propertyDetailsRow: {
    border: "black 1px solid",
    paddingLeft: 10,
  },
  rowTextSize: {
    fontSize: 10,
  },
  blackBackgroundWhiteText: {
    backgroundColor: "#000",
    color: "#fff",
  },
  greyBackgroundBlackText: {
    backgroundColor: "#d5d5d5",
    color: "#000",
  },
  textAlignCenter: {
    textAlign: "center",
  },
});

const propertyDetailView = (data) => {
  const dueDate = new Date(data?.due_date)
  .toLocaleDateString("en-IN")
  .replace(/\//g, "-");
let issueDate = new Date(data?.created_at);
issueDate.setDate(issueDate.getDate());
let yearOne, yearTwo;
let currentMonth = issueDate.getMonth() + 1;
if (currentMonth >= 7) {
  yearOne = issueDate.getFullYear().toString();
  yearTwo = (Number(issueDate.getFullYear()) + 1).toString();
  yearTwo = yearTwo.substring(2);
} else {
  yearOne = (Number(issueDate.getFullYear()) - 1).toString();
  yearTwo = issueDate.getFullYear().toString();
  yearTwo = yearTwo.substring(2);
}
const fiscalYear = yearOne + "-" + yearTwo;
issueDate = issueDate.toLocaleDateString("en-IN").replace(/\//g, "-");

  const dcRateRow = () => {
    return (
      <>
        {/* <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.greyBackgroundBlackText,
            ...styles.textAlignCenter,
          }}
          span={12}
        >
          <b style={{color:'black'}}>DC Rate</b>
        </Col> 
         <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.greyBackgroundBlackText,
            ...styles.textAlignCenter,
          }}
          span={12}
        >
          <b style={{color:'black'}}>Structure Rate</b>
        </Col> 
         <Col
          style={{ ...styles.propertyDetailsRow, ...styles.textAlignCenter }}
          span={12}
        >
          {"Rs. " + data?.tax_collection?.atv?.dc_rate?.toLocaleString()}
        </Col>
        <Col
          style={{ ...styles.propertyDetailsRow, ...styles.textAlignCenter }}
          span={12}
        >
          {"Rs. " + data?.tax_collection?.atv?.structure_rate?.toLocaleString()}
        </Col> */}

        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.greyBackgroundBlackText,
            ...styles.textAlignCenter,
          }}
          span={6}
        >
          <b style={{color:'black'}}>ATV</b>
        </Col>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.greyBackgroundBlackText,
            ...styles.textAlignCenter,
          }}
          span={6}
        >
          <b style={{color:'black'}}>Total Tax</b>
        </Col>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.greyBackgroundBlackText,
            ...styles.textAlignCenter,
          }}
          span={6}
        >
          <b style={{color:'black'}}>Surcharge</b>
        </Col>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.greyBackgroundBlackText,
            ...styles.textAlignCenter,
          }}
          span={6}
        >
          <b style={{color:'black'}}>Arrears</b>
        </Col>

        <Col
          style={{ ...styles.propertyDetailsRow, ...styles.textAlignCenter }}
          span={6}
        >
          {"Rs. " + data?.tax?.annual_taxable_value?.toLocaleString()}
        </Col>
        <Col
          style={{ ...styles.propertyDetailsRow, ...styles.textAlignCenter }}
          span={6}
        >
          {"Rs. " + data?.tax?.annual_tax?.toLocaleString()}
        </Col>
        <Col
          style={{ ...styles.propertyDetailsRow, ...styles.textAlignCenter }}
          span={6}
        >
          {"Rs. " + data?.surcharge?.toLocaleString()}
        </Col>
        <Col
          style={{ ...styles.propertyDetailsRow, ...styles.textAlignCenter }}
          span={6}
        >
          {"Rs. " + data?.arrears?.toLocaleString() || 0}
        </Col>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.greyBackgroundBlackText,
            ...styles.textAlignCenter,
          }}
          span={24}
        >
          <b style={{color:'black'}}>Total Payable</b>
        </Col>
        <Col
          style={{ ...styles.propertyDetailsRow, ...styles.textAlignCenter }}
          span={24}
        >
          {"Rs. " + data?.total_tax}
        </Col>
      </>
    );
  };
  const PNDNP = () => {
    return (
      <>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.greyBackgroundBlackText,
          }}
          span={8}
        >
          <b style={{color:'black'}}>Property No</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={16}>
          {data.property_id}
        </Col>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.greyBackgroundBlackText,
          }}
          span={8}
        >
          <b style={{color:'black'}}>Demand No</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={16}>
          {data.serial_number.slice(0, -6)}
        </Col>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.greyBackgroundBlackText,
          }}
          span={8}
        >
          <b style={{color:'black'}}>PIN</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={16}>
          {data.serial_number.slice(0, -6)}
        </Col>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.greyBackgroundBlackText,
          }}
          span={8}
        >
          <b style={{color:'black'}}>Challan Type</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={16}>
          {data?.type}
        </Col>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.greyBackgroundBlackText,
          }}
          span={8}
        >
          <b style={{color:'black'}}>Address</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={16}>
          {data?.property?.address}
        </Col>
      </>
    );
  };
  const bottomFields = () => {
    let leftSideColumnsDivision = 8;
    let rightSideColumnsDivision = 16;
    return (
      <>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.greyBackgroundBlackText,
          }}
          span={leftSideColumnsDivision}
        >
          <b style={{color:'black'}}>Structure Type</b>
        </Col>
        <Col
          style={{ ...styles.propertyDetailsRow }}
          span={rightSideColumnsDivision}
        >
          {`${data?.typeOfStructures?.[0]}${data?.typeOfStructures?.[1]?", "+data?.typeOfStructures?.[1]:""}`}
        </Col>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.greyBackgroundBlackText,
          }}
          span={leftSideColumnsDivision}
        >
          <b style={{color:'black'}}>Classification</b>
        </Col>
        <Col
          style={{ ...styles.propertyDetailsRow }}
          span={rightSideColumnsDivision}
        >
          {data?.property?.valuation_classification?.classification?.name}
        </Col>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.greyBackgroundBlackText,
          }}
          span={leftSideColumnsDivision}
        >
          <b style={{color:'black'}}>Amount in words</b>
        </Col>
        <Col
          style={{ ...styles.propertyDetailsRow }}
          span={rightSideColumnsDivision}
        >
          {toWords.convert(data?.total_tax)}
        </Col>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.greyBackgroundBlackText,
          }}
          span={leftSideColumnsDivision}
        >
          <b style={{color:'black'}}>Head of Account</b>
        </Col>
        <Col
          style={{ ...styles.propertyDetailsRow }}
          span={rightSideColumnsDivision}
        >
          B01313
        </Col>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.greyBackgroundBlackText,
          }}
          span={leftSideColumnsDivision}
        >
          <b style={{color:'black'}}>Date</b>
        </Col>
        <Col
          style={{ ...styles.propertyDetailsRow }}
          span={rightSideColumnsDivision}
        ></Col>
      </>
    );
  };
  const LACASTSPT = () => {
    return (
      <>
        {/* <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.greyBackgroundBlackText,
            ...styles.textAlignCenter,
          }}
          span={8}
        >
          <b style={{color:'black'}}>
            Land Area <br /> (Sq.Yards)
          </b>
        </Col>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.greyBackgroundBlackText,
            ...styles.textAlignCenter,
          }}
          span={8}
        >
          <b style={{color:'black'}}>
            Covered Area <br /> (Sq.FT)
          </b>
        </Col>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.greyBackgroundBlackText,
            ...styles.textAlignCenter,
          }}
          span={8}
        >
          <b style={{color:'black'}}>Surcharge</b>
        </Col>

        <Col
          style={{ ...styles.propertyDetailsRow, ...styles.textAlignCenter }}
          span={8}
        >
          {data?.tax_collection?.atv?.land_area}
        </Col>
        <Col
          style={{ ...styles.propertyDetailsRow, ...styles.textAlignCenter }}
          span={8}
        >
          {data.tax_collection.atv?.covered_area}
        </Col>
        <Col
          style={{ ...styles.propertyDetailsRow, ...styles.textAlignCenter }}
          span={8}
        >
          {"Rs. " + data?.surcharge?.toLocaleString()}
        </Col>

        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.greyBackgroundBlackText,
            ...styles.textAlignCenter,
          }}
          span={12}
        >
          <b style={{color:'black'}}>
            Tax <br /> Surcharge
          </b>
        </Col>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.greyBackgroundBlackText,
            ...styles.textAlignCenter,
          }}
          span={12}
        >
          <b style={{color:'black'}}>Payable Tax</b>
        </Col>

         Values 

        <Col
          style={{ ...styles.propertyDetailsRow, ...styles.textAlignCenter }}
          span={12}
        >
          {"Rs. " + data?.surcharge?.toLocaleString()}
        </Col>
        <Col
          style={{ ...styles.propertyDetailsRow, ...styles.textAlignCenter }}
          span={12}
        >
          {"Rs. " + data?.current_year_tax?.toLocaleString()}
        </Col> */}
      </>
    );
  };
  return (
    <View style={{ ...styles.propertyDetailsContainer }}>
      <Row>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.blackBackgroundWhiteText,
          }}
          span={9}
        >
          Highway Name
        </Col>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.blackBackgroundWhiteText,
            fontSize: 12,
          }}
          span={5}
        >
          Financial Year
        </Col>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.blackBackgroundWhiteText,
          }}
          span={5}
        >
          Issue Date
        </Col>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.blackBackgroundWhiteText,
          }}
          span={5}
        >
          Due Date
        </Col>

        <Col style={{ ...styles.propertyDetailsRow }} span={9}>
          {data?.property_data?.highway?.name}
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={5}>
          {fiscalYear}
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={5}>
          {issueDate}
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={5}>
          {dueDate}
        </Col>

        {PNDNP()}

        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.greyBackgroundBlackText,
            ...styles.textAlignCenter,
          }}
          span={12}
        >
          <b style={{color:'black'}}>
            Owner Name
          </b>
        </Col>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.greyBackgroundBlackText,
            ...styles.textAlignCenter,
          }}
          span={12}
        >
          <b style={{color:'black'}}>Parentage</b>
        </Col>
        {data?.property_data?.property_owners.map((value, index) => (
          <>
            <Col
              style={{
                ...styles.propertyDetailsRow,
                ...styles.textAlignCenter,
              }}
              span={12}
            >
              {data?.property_data?.property_owners[index]?.name}
            </Col>
            <Col
              style={{
                ...styles.propertyDetailsRow,
                ...styles.textAlignCenter,
              }}
              span={12}
            >
              {data?.property_data?.property_owners[index]?.father_name}
            </Col>
          </>
        ))}
       

        {LACASTSPT()}

        {dcRateRow()}

        {bottomFields()}
      </Row>
    </View>
  );
};
const footer = (data) => {
  return (
    <View style={{ ...styles.footer }}>
      <Row>
        <Col span={12} style={{ marginBottom: 30, textAlign: "left" }}>
          <b style={{color:'black'}}> Inspector:{" "}</b>
          <b >{data?.property?.property_inspector?.user?.full_name.toUpperCase()}</b>
        </Col>

        <Col span={12} style={{ marginBottom: 30, textAlign: "right" }}>
        <b style={{color:'black'}}> CELL:{" "}</b>
          <b>{data?.property?.property_inspector?.user?.phone}</b>
        </Col>
        <Col span={24} style={{ marginBottom: 30, textAlign: "right" }}>
        <b style={{color:'black'}}> Email:{" "}</b>
           <b >{data?.property?.property_inspector?.user?.email}</b>
        </Col>

        <Col span={24} style={{ marginBottom: 30, marginTop: 100 }}>
          <b style={{color:'black'}}>
            Assessing Authority <br />
            Highways/Motorways
          </b>
        </Col>
      </Row>
    </View>
  );
};
const FeeInvoicePart1 = ({ data }) => { 
  return (
  <Document>
    <Page pageNumber={1} wrap>
      <View style={{ ...styles.page }}>
        <View style={styles.mainHeader}>
          <View style={{ ...styles.headerLogo }}>
            <img src={Logo}></img>
          </View>
          <View style={{ ...styles.headerTextSection, ...styles.rowTextSize }}>
            <Text>
              <b style={{color:'black'}}>FORM P.H.10</b>
            </Text>
            <Text style={{ ...styles.rowTextSize }}>[See Rule(13)]</Text>
          </View>
        </View>
        <View style={{ ...styles.taxPersonsSection }}>
          <Text style={{ ...styles.rowTextSize }}>
            <b style={{color:'black'}}>PH10 Serial No: </b><b> {data?.serial_number || "N/A"}</b>
          </Text>
          <Row>
            <Col span={12} style={{ textAlign: "left" }}>
              <Text style={{ ...styles.rowTextSize }}>
                 <b style={{color:'black'}}>Circle: </b><b>{data?.property_data?.circle.name}</b>
              </Text>
            </Col>
            <Col span={12} style={{ textAlign: "right" }}>
              <Text style={{ ...styles.rowTextSize }}>
                <b style={{color:'black'}}>(Department's Copy)</b>
              </Text>
            </Col>
          </Row>
        </View>

        {propertyDetailView(data)}
        {footer(data)}
      </View>
    </Page>
  </Document>
)};

export default FeeInvoicePart1;
